// extracted by mini-css-extract-plugin
export var addressFields = "_px-0";
export var animationContainer = "_px-1";
export var footer = "_px-2";
export var lineItems = "_px-3";
export var modalContent = "_px-4";
export var orderName = "_px-5";
export var strong = "_px-6";
export var warning = "_px-7";